import type { MappedContentData, MappedGtmEventName } from './gtm.types';

export const USER_SCOPE_CACHE_KEY = 'gtm_user_scope_v1';
export const MAPPED_GTM_EVENTS = [
  'user_created',
  'user_email_verified',
  'user_kyc_completed',
  'user_kyc_started',
  'user_logged_in',
  // when the user clicks Top Up in the low balance threshold popup.
  'low_balance_threshold_event_click',
  // when the user selects a bundle and payment method and proceeds to the payment provider
  'low_balance_threshold_event_deposit_order',
  // when the user clicks the bundle price / purchase button in the Shop modal
  'low_balance_event_click',
  // when the user selects a bundle and payment method and proceeds to the payment provider
  'low_balance_event_deposit_order',
] as const;

export const DEFAULT_EVENT_CONTENT = {
  user_created: { content_type: 'form', content_id: 'registration' },
  user_email_verified: { content_type: 'verification', content_id: 'email_verification' },
  user_kyc_started: { content_type: 'verification', content_id: 'kyc' },
  user_kyc_completed: { content_type: 'verification', content_id: 'kyc' },
  user_logged_in: { content_type: 'form', content_id: 'login' },
} satisfies Partial<Record<MappedGtmEventName, MappedContentData>>;

export const EVENTS_WITHOUT_DEFAULT_CONTENT = [
  'low_balance_threshold_event_click',
  'low_balance_threshold_event_deposit_order',
  'low_balance_event_click',
  'low_balance_event_deposit_order',
] as const satisfies ReadonlyArray<MappedGtmEventName>;
